import { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { isAdmin, isChampion } from "../auth/admin";

/**
 * True when the signed-in account has the Champion app role, or is an admin
 * (see src/auth/admin.ts). Champions can open the AI Champions page and edit
 * it through Champion admin.
 */
export function useIsChampion(): boolean {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  return useMemo(() => {
    const claims = account?.idTokenClaims as Record<string, unknown> | undefined;
    return isChampion(claims) || isAdmin(claims);
  }, [account]);
}
